/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Day_PendingInputs */

const en_platform_day_pending = /** @type {(inputs: Platform_Day_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`waiting for your yes`)
};

const pl_platform_day_pending = /** @type {(inputs: Platform_Day_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`czekają na Twoje „tak”`)
};

/**
* | output |
* | --- |
* | "waiting for your yes" |
*
* @param {Platform_Day_PendingInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_day_pending = /** @type {((inputs?: Platform_Day_PendingInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Day_PendingInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_day_pending(inputs)
	return en_platform_day_pending(inputs)
});